import { Permission } from "@/models";
import { MacroIcon } from "@/components/atoms/icons";

import { IGIREMenuItem } from "../../models/router.types";
import { PathNamekAppsRoutes, PathNamekRoutes } from "../../constants";

export const macroMenuItems: IGIREMenuItem[] = [
  {
    label: "Macrogeneradores",
    icon: <MacroIcon />,
    data: PathNamekAppsRoutes.MACROGENERATORS,
    align: "start",
    permission: {
      must: Permission.MACROGENERADORES_CONSULTA,
      exhaustive: false,
    },
    items: [
      {
        label: "Gestión de macrogeneradores",
        url: `/#/${PathNamekAppsRoutes.MACROGENERATORS}/list`,
        permission: {
          must: Permission.MACROGENERADORES_CONSULTA,
        },
      },
      {
        label: "Tablero",
        url: `/#/${PathNamekRoutes.POWERBI.DASHBOARD}/mg.dv-powerbi`,
        permission: {
          must: Permission.MACROGENERADORES_DASHBOARD,
        },
      },
    ],
  },
];
